import { Component, computed, EventEmitter, inject, Input, Output, signal } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BANK_CONFIG } from "src/app/bank.config";
import { ALERT_TYPE, SUCCESS_MESSAGES } from "src/app/constants";
import { Enums } from "src/app/Shared/enums";
import { SharedService } from "src/app/Shared/shared-service.service";
import { FinanceAccount } from "src/model/financeAccount.model";
import { FinanceAccountService } from "src/services/finance-account.service";

@Component({
  selector: "app-add-finance-account",
  standalone: false,
  templateUrl: "./add-finance-account.component.html",
  styleUrl: "./add-finance-account.component.scss",
})
export class AddFinanceAccountComponent {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private faService = inject(FinanceAccountService);

  fa = signal<FinanceAccount>(new FinanceAccount());
  isOtherBank = computed(() => {
    return !BANK_CONFIG.some(b => b.bankName === this.fa().Bank);
  })
  disabledSubmit = false;
  @Input() isEdit = false;
  @Input() faToUpdate: FinanceAccount;
  @Output() passEntry = new EventEmitter<any>();

  readonly BANK_CONFIG = BANK_CONFIG;

  ngOnInit() {
    this.reset();
  }

  async submit() {
    this.disabledSubmit = true;
    const errors = this.fa().nullValidate();
    if (errors.length > 0) {
      this.sharedService.openAlert(errors.map(e => `- ${e}`).join('\n'), ALERT_TYPE.DANGER);
      this.disabledSubmit = false;
    } else {
      let result: FinanceAccount;
      let message = '';
      try {
        if (this.isEdit) {
          result = await this.faService.putUpdateFinanceAccount(this.fa());
          message = SUCCESS_MESSAGES.UPDATED('finance account');
        } else {
          result = await this.faService.postAddFinanceAccount(this.fa());
          message = SUCCESS_MESSAGES.ADDED('finance account');
        }
        if (result !== undefined) {
          this.passEntry.emit(result);
          this.activeModal.close();
          this.sharedService.openAlert(message, ALERT_TYPE.SUCCESS);
        }
      } catch {
        this.disabledSubmit = false;
      }
    }
  }

  // get isOtherBank(): boolean {
  //   return !BANK_CONFIG.some(b => b.bankName === this.fa().Bank);
  // }

  bankChanged(newValue: string) {
    this.fa.update(fa => {
      fa.Bank = newValue !== 'Other' ? newValue : null;
      return Object.assign(new FinanceAccount(), fa);
    });
  }

  reset() {
    if (this.isEdit) {
      this.fa.set(Object.assign(new FinanceAccount(), this.faToUpdate));
    } else {
      this.fa.set(new FinanceAccount());
      this.fa().Bank = BANK_CONFIG[0].bankName;
    }
  }

  close() {
    this.activeModal.close();
  }
}
